import React from 'react';

import Icon from '../Icon';
import styles from './ExternalContentIcon.module.scss';

const ExternalContentIcon = props => {
    const {session_content_type, disabled, className = '', style = {}} = props;

    return (
        <Icon
            className={[className, styles.ExternalContentIcon, styles[session_content_type] || '', disabled ? styles.disabled : ''].join(' ')}
            style={style}
        />
    );
};

export default ExternalContentIcon;
